import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import dayjs from 'dayjs'
import { setRemoteCall } from '../../remote'
import { useGlobalState, getGlobalState } from '../../store'
import ProjectComponent from './ProjectComponent'
import Person from './Person'
import {
  ProjectTitle,
  ProjectColor,
  Project,
  Resources,
  ResourceList,
  Weekday,
  ColummnTitle,
  WeekdayWrap,
  TotalResources,
} from './styled'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

const WeekdayComponent = ({
  i,
  column,
  pickerSource,
  viewOptions,
  getSceneProjectsPayload,
  collapsedProjects,
  projectsPayloadMap,
  getSceneChildResourcesPayload,
  getSortedGroups,
  onClick,
  onResourceCardDrop,
  users,
  setDayResources,
  dayResources,
}) => {
  const projectTypes = getGlobalState('projectTypes')
  // const [projectTypes, setProjectTypes] = useGlobalState('projectTypes')
  const userTypes = getGlobalState('userTypes')
  // const [userTypes, setUserTypes] = useGlobalState('userTypes')
  // const [projects, setProjects] = useGlobalState('projects')
  const resourceTypes = getGlobalState('resourceTypes')
  // const [resourceTypes, setResourceTypes] = useGlobalState('resourceTypes')

  const unavailable = useRef(0)
  const unolacated = useRef(0)

  let projectResourcesObj = {}
  let allocatedUsers = []
  let unavailableUsers = []
  let unallocatedUsers = []
  const projectsPayload = useMemo(() => {
    const currentColumnDate = dayjs(column.date, 'DD/MM/YYYY')

    let prjPayl = projectsPayloadMap.map((prjPl) => {
      const thisResources = getSceneChildResourcesPayload(
        prjPl.id,
        null,
        column.id
      )

      // Filter out users who are outside their employment date range
      const filteredResources = thisResources.filter((resource) => {
        // Only filter users (not resources)
        if (resource.cardType !== 'users') return true
        // Check employment date range
        if (
          (resource.contractStartDate &&
            currentColumnDate.isBefore(
              dayjs(resource.contractStartDate),
              'day'
            )) ||
          (resource.contractEndDate &&
            currentColumnDate.isAfter(dayjs(resource.contractEndDate), 'day'))
        ) {
          return false
        }

        return true
      })

      projectResourcesObj[prjPl.id] = filteredResources
      allocatedUsers = [
        ...allocatedUsers,
        ...(filteredResources.filter((res) => res.cardType === 'users') || []),
      ]
      return prjPl
    })

    if (
      viewOptions.displayType === 'day' &&
      JSON.stringify(dayResources) !== JSON.stringify(allocatedUsers)
    ) {
      setDayResources(allocatedUsers)
    }

    return prjPayl
  }, [projectsPayloadMap])
  // useEffect(() => {
  //   //hacked set state
  //   if (
  //     viewOptions.displayType === 'day' &&
  //     dayResources.length < 1 &&
  //     allocatedUsers.length > 0
  //   ) {
  //     setDayResources(allocatedUsers)
  //   }
  // }, [viewOptions, dayResources, projectsPayloadMap])

  /**
   * get unalocated users
   */
  const getUnalocatedUsers = useMemo(() => {
    const currentColumnDate = dayjs(column.date, 'DD/MM/YYYY')

    return users
      .filter((user) => {
        return !allocatedUsers.find((allocatedUser) => {
          return allocatedUser._id === user._id
        })
      })
      .map((user) => {
        let unavailType = ''

        // Check employment date range
        if (
          (user.contractStartDate &&
            currentColumnDate.isBefore(dayjs(user.contractStartDate), 'day')) ||
          (user.contractEndDate &&
            currentColumnDate.isAfter(dayjs(user.contractEndDate), 'day'))
        ) {
          unavailType = 'outOfContract'
          unavailableUsers.push({
            ...user,
            currentUnavail: ['Terminou', 'Contrato'],
          })
        } else {
          //check if user is available (vacation/absence)
          if (user.availability && Array.isArray(user.availability)) {
            user.availability.map((avail) => {
              let dateStart = avail[0]
              let dateEnd = avail[1]
              let availType = avail[2]
              if (
                currentColumnDate.isBetween(
                  dayjs(dateStart).format('YYYY-MM-DD'),
                  dayjs(dateEnd).format('YYYY-MM-DD'),
                  'day',
                  '[]'
                )
              ) {
                unavailType = availType
                unavailableUsers.push({ ...user, currentUnavail: avail })
              }
            })
          }
        }

        if (unavailType === '') {
          unallocatedUsers.push(user)
        }
        return { ...user, unavailType }
      })
  }, [projectsPayloadMap])

  return (
    <Weekday key={column.id} size={viewOptions.displayType}>
      <ColummnTitle color={'#474f58'}>
        <TotalResources>{unallocatedUsers.length}</TotalResources>
        {column.name} <span>{column.date}</span>{' '}
      </ColummnTitle>

      <WeekdayWrap {...column.props} size={viewOptions.displayType}>
        {unavailableUsers && (
          <ProjectColor className={'animated fadeIn'}>
            <ProjectTitle
              cursor={'pointer'}
              color={'#ccc'}
              style={{
                color: '#676a7a',
              }}
              onClick={() => {
                if (unavailable.current.style.display === 'none') {
                  unavailable.current.style.display = 'block'
                } else {
                  unavailable.current.style.display = 'none'
                }
              }}
            >
              <span
                style={{
                  background: '',
                }}
              >
                {unavailableUsers.length}
              </span>{' '}
              {'Ausências'}
              <span className={'open'}></span>
            </ProjectTitle>

            <Project>
              <div
                style={{ maxHeight: '25vh', overflow: 'auto', display: 'none' }}
                ref={unavailable}
              >
                <Resources>
                  <ResourceList>
                    {unavailableUsers.map((user, i) => {
                      // return <div key={i}>{user.firstName}</div>
                      return (
                        <Person
                          disabledrag={true}
                          key={i}
                          onClick={onClick}
                          // viewType={viewOptions.viewType}
                          data={user}
                          types={userTypes}
                        />
                      )
                    })}
                  </ResourceList>
                </Resources>
              </div>
            </Project>
          </ProjectColor>
        )}
        {/* <ProjectColor className={'animated fadeIn'}>
          <ProjectTitle
            cursor={'pointer'}
            color={'#ccc'}
            style={{
              color: '#676a7a'
            }}
            // onClick={() => setUnolocatedCollapse(!toggleUnolocatedCollapse)}
            onClick={() => {
              if (unolacated.current.style.display === 'none') {
                unolacated.current.style.display = 'block'
              } else {
                unolacated.current.style.display = 'none'
              }
            }}
          >
            <span
              style={{
                background: ''
              }}
            >
              {unallocatedUsers.length}
            </span>{' '}
            {'Não alocado'}
            <span className={'open'}></span>
          </ProjectTitle>

          <Project>
            <div
              style={{ maxHeight: '25vh', overflow: 'auto', display: 'none' }}
              ref={unolacated}
            >
              <Resources>
                <ResourceList>
                  {unallocatedUsers.map((user, i) => {
                    // return <div key={i}>{user.firstName}</div>
                    return (
                      <Person
                        disabledrag={true}
                        key={i}
                        onClick={onClick}
                        // viewType={viewOptions.viewType}
                        data={user}
                        types={userTypes}
                      />
                    )
                  })}
                </ResourceList>
              </Resources>
            </div>
          </Project>
        </ProjectColor> */}
        {useMemo(() => {
          const sortedProjects = projectsPayload?.sort((a, b) => {
            return Number(a.code) < Number(b.code) ? -1 : 1
          })

          return sortedProjects?.map((project, i) => {
            if (!project) return null

            // now we need to get the sorted grouped data
            const {
              usedProjectGroups,
              projectResourcesGroup,
              sortedGroups,
              sortedProjectResources,
            } = getSortedGroups(projectResourcesObj[project.id] || [])

            const type = projectTypes
              ? projectTypes.find((t) => t._id === project.t)
              : {}
            // if (viewOptions.searchProject) {
            //   const regex = new RegExp(
            //     viewOptions?.searchProject?.toLowerCase().replace(' ', '(.*?)'),
            //     'g'
            //   )

            //   if (
            //     !regex.test(project?.name?.toLowerCase()) &&
            //     !regex.test(project?.code?.toLowerCase())
            //   ) {
            //     return null
            //   }
            // }
            return (
              <ProjectComponent
                key={project.id}
                column={column}
                pickerSource={pickerSource}
                viewOptions={viewOptions}
                onClick={onClick}
                onResourceCardDrop={onResourceCardDrop}
                type={type}
                resourceTypes={resourceTypes}
                project={project}
                sortedProjectResources={sortedProjectResources}
                sortedGroups={sortedGroups}
                projectResources={projectResourcesObj[project.id]}
                usedProjectGroups={usedProjectGroups}
                projectResourcesGroup={projectResourcesGroup}
                collapsedProjects={collapsedProjects}
              />
            )
          })
        }, [projectsPayload, projectResourcesObj, projectTypes, column, pickerSource, viewOptions, onClick, onResourceCardDrop, resourceTypes, collapsedProjects, getSortedGroups])}
      </WeekdayWrap>
    </Weekday>
  )
}

export default React.memo(WeekdayComponent, (prevProps, nextProps) => {
  // Always re-render if projectsPayloadMap changed (relations updated)
  if (prevProps.projectsPayloadMap !== nextProps.projectsPayloadMap) {
    return false
  }
  
  return (
    prevProps.column.id === nextProps.column.id &&
    prevProps.viewOptions?.displayType === nextProps.viewOptions?.displayType &&
    prevProps.viewOptions?.viewType === nextProps.viewOptions?.viewType &&
    prevProps.viewOptions?.type === nextProps.viewOptions?.type &&
    prevProps.viewOptions?.search === nextProps.viewOptions?.search &&
    prevProps.viewOptions?.showApproval === nextProps.viewOptions?.showApproval &&
    prevProps.viewOptions?.showOnlyTransfers === nextProps.viewOptions?.showOnlyTransfers &&
    prevProps.pickerSource === nextProps.pickerSource &&
    prevProps.collapsedProjects === nextProps.collapsedProjects &&
    prevProps.users === nextProps.users
  )
})
